// This is what the module will return. We define some of the functiosn in this namespace
// to be able to test them easely
var expose = {};

// the css is injected automatically
// require('!style-loader!css-loader!stylus-loader!./backlink.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var pagebreak = require("../pagebreak/pagebreak");

expose.parse = function (text, next) {
    strip(require('raw!./backlink.html'), function(html) {
        // TODO: check if ?back=true exists
        var url = window.location.href;
        if ( url.indexOf('?back=true') > -1 || url.indexOf('&back=true') > -1) {
            text += html;
        }

        next(text);
    });
};

module.exports = expose;



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/backlink/backlink.js